import type { ConfigRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ContentObjectDetailDataObject } from 'models/service';

type ContentObjectPathRequestParams = { id: string };
type ContentObjectQueryRequestParams = { sort?: 'chronological' | 'popularity' };

export const getContentObject = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<ContentObjectQueryRequestParams, ContentObjectPathRequestParams>) =>
  apiClient.get<ContentObjectDetailDataObject, ApiClientResponse<ContentObjectDetailDataObject>>(
    routes.contentObjects.get(id),
    {
      params,
    },
  );
